import React from "react";
import { observer } from "mobx-react";
import { WeaSelectGroup } from "ecCom";
import * as util from "../../util";

@observer
export default class DateGroupItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaSelectGroup
        {...bindObj.bind()}
        value={util.toJS(bindObj.value, true)}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
        isMobx
        mr0
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/SelectGroupItem.js